import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import axios from './api/axiosConfig';
import ProtectedRoute from './util/ProtectedRoute';
import { NotificationProvider } from "./util/NotificationContext";
import { SearchProvider } from "./util/SearchContext";

import { useNotification } from "./util/NotificationContext";
import { useSearch } from "./util/SearchContext";


import Header from './components/Header';
import HomePage from './pages/HomePage';
import MyRecipesPage from './pages/MyRecipesPage';
import DiscoverPage from './pages/DiscoverPage';
import RecipePage from './pages/RecipePage';
import InitialRecipeLoader from './components/loaders/InitialRecipeLoader';

export default function App() {
  return (
    <NotificationProvider>
      <Router>
        <SearchProvider>
          <AppContent />
        </SearchProvider>
      </Router>
    </NotificationProvider>
  );
}

function AppContent() {
  const location = useLocation();
  const { loadingHttpSearch } = useSearch();


  const hideSearch = !location.pathname.startsWith('/recipe/') && !location.pathname.startsWith('/my-recipes') && !loadingHttpSearch;
  const currentPage = location.pathname + location.search;

  // Reset home page state
  const resetHomePage = () => {
    setRecipe(null);
    setLoadingHttpSearch(false);
  };

  return (
    <div className="min-h-screen bg-white text-gray-800 font-sans relative">
      <Header
        resetHomePage={resetHomePage}
        hideSearch={hideSearch}
      />

      <div className='bg-gray-50 min-h-screen'>
        {/* If searching, only display loader (remove old content) */}
        {loadingHttpSearch ? (
          <div className="max-w-6xl mx-auto px-2 sm:px-6 py-8">
            <InitialRecipeLoader />
          </div>
        ) : (
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/discover" element={<DiscoverPage />} />
            <Route path="/my-recipes" element={<ProtectedRoute><MyRecipesPage /></ProtectedRoute>} />
            <Route path="/recipe/:id" element={<RecipePage />} />
          </Routes>
        )}
      </div>

    </div>
  );
}
